var _path, _path2, _mask, _g, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotionDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 452,
    viewBox: "0 0 266 452",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133 264.289C59.66 264.289 0 205.013 0 132.145C0 59.2763 59.66 0 133 0C206.34 0 266 59.2763 266 132.145C266 205.013 206.34 264.289 133 264.289ZM133 75.5111C101.46 75.5111 76 100.807 76 132.145C76 163.482 101.46 188.778 133 188.778C164.54 188.778 190 163.482 190 132.145C190 100.807 164.16 75.5111 133 75.5111Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133 452C59.66 452 0 392.933 0 320.322C0 247.712 59.66 188.645 133 188.645C206.34 188.645 266 247.712 266 320.322C266 392.933 206.34 452 133 452ZM133 263.889C101.46 263.889 76 289.096 76 320.322C76 351.549 101.46 376.756 133 376.756C164.54 376.756 190 351.549 190 320.322C190 289.096 164.16 263.889 133 263.889Z",
    fill: "#3098F3"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 188,
    width: 266,
    height: 264
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.868 452C59.601 452 0 392.893 0 320.232C0 247.571 59.601 188.464 132.868 188.464C206.136 188.464 265.737 247.571 265.737 320.232C265.737 392.893 206.136 452 132.868 452ZM132.868 263.76C101.36 263.76 75.9248 288.984 75.9248 320.232C75.9248 351.48 101.36 376.704 132.868 376.704C164.377 376.704 189.812 351.48 189.812 320.232C189.812 288.984 163.998 263.76 132.868 263.76Z",
    fill: "#D9D9DA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.868 263.964C59.601 263.964 0 204.857 0 132.196C0 59.5356 59.601 0.428223 132.868 0.428223C206.136 0.428223 265.737 59.5356 265.737 132.196C265.737 204.857 206.136 263.964 132.868 263.964ZM132.868 75.7242C101.36 75.7242 75.9248 100.948 75.9248 132.196C75.9248 163.444 101.36 188.668 132.868 188.668C164.377 188.668 189.812 163.444 189.812 132.196C189.812 100.948 163.998 75.7242 132.868 75.7242Z",
    fill: "#082C4E"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.23,
    cy: 360.946,
    rx: 37.4648,
    ry: 36.8884,
    fill: "#082C4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionDesktop);
export default __webpack_public_path__ + "static/media/motion-desktop.f3eabc6fd8f53ad7c90740f287edb0d7.svg";
export { ForwardRef as ReactComponent };